import type { VoidComponent } from "solid-js";
import { getOwner, runWithOwner } from "solid-js";
import { TextAndIconButton } from "../../../components/button/Button";
import { useTranslation } from "../../../state/i18n";
import { DestructiveModal } from "../../../components/modal/Modal";
import FormVersionService from "../../../services/FormVersionService";
import NavigationService from "../../../services/NavigationService";
import { useModalManager } from "../../../components/modal/ModalManager";

const HeaderBackButton: VoidComponent = () => {
  const owner = getOwner();
  const { t } = useTranslation();
  const { open } = useModalManager();

  return (
    <TextAndIconButton
      icon="chevronLeft"
      variant="tertiary"
      size="medium"
      text={t(($) => $.FORM_EDITOR_HEADER_BACK_BUTTON)}
      onClick={() => {
        if (FormVersionService.hasUpdated()) {
          open({
            content: () => (
              <DestructiveModal
                cancelLabel={t(($) => $.CANCEL_BUTTON)}
                confirmLabel={t(($) => $.DISCARD_UNSAVED_CHANGES_BUTTON)}
                title={t(($) => $.FORM_EDITOR_UNSAVED_CHANGES_MODAL_TITLE)}
                description={t(($) => $.FORM_EDITOR_UNSAVED_CHANGES_MODAL_DESCRIPTION)}
                onConfirm={() => {
                  runWithOwner(owner, () => {
                    NavigationService.exitFormEditor();
                  });
                }}
              />
            ),
          });
        } else {
          runWithOwner(owner, () => {
            NavigationService.exitFormEditor();
          });
        }
      }}
    />
  );
};

export default HeaderBackButton;
